module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-crm/02-70bf3e6d766b0580ccb7a63a00b2ce01.png";